import 'reflect-metadata';
import { container } from 'tsyringe';

export function overrideResource<T>(key: string, resource: any): void {
  container.register<T>(key, { useClass: resource });
}
